import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { User } from "../../utils/types";
import { set } from 'lodash';

const initialState = {
  isLoading: false,
  isSignedIn: false,
  user: User,
  selectedSpecialty: {
    id: 0,
    name: "",
    image: "",
  },
  selectedDoctor: {
    id: 0,
    name: "",
    profession: "",
    image: "",

  },
  selectedLocation: {
    id: 0,
    name: "",
    address: "",
  },
  first_name: "",
  last_name: "",
  email: "",
  access_token: "",
  activePrescriptions: [],
};

const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUserPending: (state) => {
      state.isLoading = true;
    },
    getUserSuccessful: (state, { payload }) => {
      state.isLoading = false;
      state.user = payload;
      state.isSignedIn = true;
    },
    setSelectedSpecialty: (state, { payload }) => {
      state.selectedSpecialty = payload;
    },
    setSelectedDoctor: (state, { payload }) => {
      state.selectedDoctor = payload;
    },
    setSelectedLocation: (state, { payload }) => {
      state.selectedLocation = payload;
    },

    getFirstName: (state, { payload }) => {
      state.first_name = payload;
    },
    getLastName: (state, { payload }) => {
      state.last_name = payload;
    },
    getEmailAddress: (state, { payload }) => {
      state.email = payload;
    },
    getAccessToken: (state, { payload }) => {
      state.access_token = payload;
    },
    allActivePrescriptions: (state, { payload }) => {
      state.activePrescriptions = payload;
      state.isLoading = false;
    },
    resetUser: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(initializeFromStorage.fulfilled, (state, action) => {
      if (action.payload) {
        state.user = action.payload.user;
        state.access_token = action.payload.access_token;
        state.isSignedIn = action.payload.isSignedIn;
      }
    });
  },
});

const { reducer, actions } = UserSlice;

export const {
  getUserPending,
  getUserSuccessful,
  setSelectedSpecialty,
  setSelectedDoctor,
  setSelectedLocation,
  getFirstName,
  getLastName,
  getEmailAddress,
  getAccessToken,
  allActivePrescriptions,
  resetUser,
} = actions;

export const initializeFromStorage = createAsyncThunk(
  'user/initializeFromStorage',
  async () => {
    try {
      const userSession = localStorage.getItem('@user-session');
      if (userSession) {
        const parsedSession = JSON.parse(userSession);
        return {
          user: {
            access_token: parsedSession.token,
            scope: "user",
            corporateHealthFacility: parsedSession.user.corporateHealthFacility || { id: '', name: '' },
            token_type: "Bearer",
            expires_in: 3600,
            user: parsedSession.user
          },
          access_token: parsedSession.token,
          isSignedIn: true,
          corporateHealthFacility: parsedSession.user.corporateHealthFacility || { id: '', name: '' }
        };
      }
      return null;
    } catch (error) {
      console.error('Error initializing from storage:', error);
      return null;
    }
  }
);

export default reducer;
